module.exports = __webpack_public_path__ + "static/media/Edit-red.e298ae8e.svg";